import { render } from "./QuizModel.vue?vue&type=template&id=1e1a8aa8&scoped=true"
import script from "./QuizModel.vue?vue&type=script&lang=js"
export * from "./QuizModel.vue?vue&type=script&lang=js"

import "./QuizModel.vue?vue&type=style&index=0&id=1e1a8aa8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e1a8aa8"]])

export default __exports__